import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import Offer from './components/Offer';
import { PaymentResult } from './components/PaymentResult';
import { AdditionalServices } from './components/AdditionalServices';
import { AdditionalOptions } from './components/AdditionalOptions';
import { RateMyDelivery } from './components/ratemydelivery';
import { TrackMyDelivery } from './components/trackmydelivery';
import Redirect from './components/Redirect';
import ShipmentListPage from './components/ShipmentListPage';
import LoggedInPage from './components/LoggedInPage';
import LoggedOut from './components/LoggedOut';
import UserPreferencePage from './components/UserPreferencePage';
import SilentRefreshPage from './components/SilentRefreshPage';
import './custom.scss';
import AuthService from './services/AuthService';

export default class App extends Component {
    static displayName = App.name;
    static __busyCount = 0;

    constructor(props) {
      super(props);
      this.state = {
          loaded: false,
          busy: false
      };
  }

  async componentDidMount() {
    if(window.location.href.indexOf('/silentrefresh') < 0) {
      var authService = await AuthService.getInstance();
      var user = await authService.getUser();    
      // if we have a user, check if user has a valid token that has not expired
      if((user && user.expired)) {
        //console.log('User found but token has expired');
        var tries = 1;
        while(tries++ < 10 && user.expired === true) {
          // wait for it to (hopefully refresh)
          //console.log('awaiting user refresh....')
          await new Promise(resolve => setTimeout(resolve, tries * 200));
          user = await authService.getUser();
          console.log('current user state', user);          
        }
      }
      await new Promise(resolve => setTimeout(resolve, 100));
      //console.log('ending app componentDidMount, setting loaded');
    }
    this.setState({loaded: true});
  }

  setGlobalBusy = () => {
    App.__busyCount++;
    this.setState({busy: true});
  };

  clearGlobalBusy = () => {
    App.__busyCount--;
    console.log('checking global busy', App.__busyCount);
    if(App.__busyCount <= 0) {
      App.__busyCount = 0;
      console.log('clearing global busy');
      this.setState({busy: false});
    }
  }

  render () {
    // NOTE: No routes can contain /api/, /identity/ or /identityadmin/ - these are excluded from the service worker
    return (
      this.state.loaded === true ? 
      <React.Fragment>        
          <Route path='/loggedin' component={LoggedInPage} />
          <Route path='/silentrefresh' component={SilentRefreshPage} />
          <Route path='/t/:jobid' component={TrackMyDelivery} />
          <Route render={({ location }) => {
                  var shouldRenderLayout =
                      location.pathname.indexOf('/t/') === -1 &&
                      location.pathname.indexOf('/silentrefresh') === -1;
            return shouldRenderLayout ? 
              <Layout busy={this.state.busy}>
                <Route exact path='/' component={ShipmentListPage} />
                <Route path='/welcome' component={Home} />
                <Route path='/o/:jobid'>
                  <Offer clearGlobalBusy={this.clearGlobalBusy} setGlobalBusy={this.setGlobalBusy} busy={this.state.busy}/>
                </Route>
                <Route path='/as/:jobid' component={AdditionalServices} />
                <Route path='/ao/:jobid' component={AdditionalOptions} />
                <Route path='/r/:jobid' component={RateMyDelivery} />
                <Route path='/rd/:jobid'>
                  <Redirect clearGlobalBusy={this.clearGlobalBusy} setGlobalBusy={this.setGlobalBusy} busy={this.state.busy}/>
                </Route>
                <Route path='/pr/:jobid' component={PaymentResult} />
                <Route path='/Preferences' >
                  <UserPreferencePage clearGlobalBusy={this.clearGlobalBusy} setGlobalBusy={this.setGlobalBusy} busy={this.state.busy}/>
                </Route>
                <Route path='/Shipments' component={ShipmentListPage} />                        
                <Route path='/loggedout' component={LoggedOut} />
              </Layout> : null 
          }} />
      </React.Fragment> :
      <div className="global-splash">
        <div className="lds-dual-ring">
          <img src="images/footer-logo.gif" alt=""/>
        </div>
      </div>
    );
  }
}
